import moment from "moment";

/** /managerDashboard/stats/latest-data-received
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20GetLatestDataReceivedInfoResponseDto
 */
export function getLatestDataReceivedResp() {
  return {
    latestDataReceivedTimestamp: moment.utc().subtract(2, "days").valueOf(),
  };
}
